<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5" lg="4">
            <v-card flat class="text-center pa-6">
              <v-avatar color="red lighten-5" size="88" class="mb-4">
                <v-icon color="red darken-1" size="48">mdi-lock-alert-outline</v-icon>
              </v-avatar>
              <v-card-title class="justify-center text-h5">
                Accès non autorisé
              </v-card-title>
              <v-card-text class="text-body-1">
                Votre compte ne dispose pas des droits nécessaires pour accéder à
                cette interface.
                <br />
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn color="primary" text @click="logout">
                  <v-icon left>mdi-logout</v-icon>
                  Se déconnecter
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "Unauthorized",
  methods: {
    logout() {
      this.$keycloak.logout();
    }
  }
};
</script>
